export default __webpack_public_path__ + "media/images/front/wavy/lighter_1-31893a077ede68b3c39f9bfbe4cde46b.png";